import { filter, isEmpty } from 'lodash'

export const showActiveFiltersPivot = (columnsInfo, tableApi, tAgGrid) => {
  if (isEmpty(columnsInfo)) return []

  const rowGroups = filter(columnsInfo, (val) => val.rowGroupIndex !== null)
  const values = filter(columnsInfo, (val) => val.aggFunc !== null)
  const labels = filter(columnsInfo, (val) => val.pivotIndex !== null)

  return isEmpty(rowGroups) && isEmpty(values) && isEmpty(labels)
    ? {}
    : {
        [tAgGrid('groups')]: getIdsByFieldsObj(rowGroups, tableApi),
        [tAgGrid('values')]: getIdsByFieldsObj(values, tableApi),
        [tAgGrid('pivots')]: getIdsByFieldsObj(labels, tableApi)
      }
}

const getIdsByFieldsObj = (listObj, tableApi) => {
  if (!listObj || isEmpty(listObj)) return []

  return listObj.map(({ colId }) => getLabelById(colId, tableApi))
}

const getLabelById = (fieldId, tableApi) => {
  let fieldLabel = ''
  tableApi.gridCore.columnApi.columnController.columnDefs.forEach((element) => {
    if (element?.field === fieldId) {
      fieldLabel = element.headerName ?? fieldId
    }
  })

  return fieldLabel
}
